<div class="table-container">
  <table class="table">
    <div class="table-container">
      <table class="table">
        <tr *ngIf="showCreateForm">
          <td colspan="1">
            <div class="create-media-form">
              <media-details [currentTicket]="currentTicket"></media-details>
            </div>
          </td>
        </tr>

        <tbody>
          <ng-container *ngFor="let media of medias | async">
            <tr
              id="tr"
              (click)="selectMedia(media)"
              [class.selected]="media === selectedMedia"
            >
              <span>{{ media.name }}</span>
              -
              <span>{{ media.extension }}</span>
            </tr>

            <tr *ngIf="media === selectedMedia" class="details-row">
              <td colspan="1">
                <div class="details-container">
                  <media-details
                    [currentTicket]="currentTicket"
                  ></media-details>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </table>
</div>
